import SectionRating from './SectionRating';

export default SectionRating;
